import AnalyticsTracker from './analytics_tracker'
import { whenAllowedToTrack } from './analytics_tracker/util'

import env from '@polleverywhere/core/lib/env'

function injectGoogleTagManager (gtmId) {
  (function (w, d, s, l, i) {
    w[l] = w[l] || []
    w[l].push({
      'gtm.start': new Date().getTime(),
      event: 'gtm.js'
    })
    var f = d.getElementsByTagName(s)[0]
    var j = d.createElement(s)
    var dl = l !== 'dataLayer' ? '&l=' + l : ''
    j.async = true
    j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl
    f.parentNode.insertBefore(j, f)
  })(window, document, 'script', 'dataLayer', gtmId)
}

/**
 * Sent events to GTM
 */
export default (app) => {
  const gtmId = env.get('google_tag_manager_id')
  if (!gtmId || gtmId === 'undefined') {
    return
  }

  window.dataLayer ||= []

  const tracker = AnalyticsTracker(app)

  tracker.on('action', (name, opts = {}) => {
    window.dataLayer.push({
      event: 'customEvent',
      eventName: name,
      eventCategory: 'action'
    })
  })

  tracker.on('event', (name, opts = {}) => {
    window.dataLayer.push({
      event: 'customEvent',
      eventName: name,
      eventCategory: 'event'
    })
  })

  whenAllowedToTrack(app, tracker).then(() => injectGoogleTagManager(gtmId))
}
